<div style="position: relative;" id="{{position}}" class="position-relative"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div>
    <div class="feature-light-bg pb-20 pt-20" [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
      <div class="feature-content-container">
        <div *ngIf="title" class="feature-title" [attr.data-aos]="textAnimation ? textAnimation : null">
          <h1 class="title-pricing-containe center mb-60"
            [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,fontWeight:fontWeight }" [ngClass]="[titleSize]"
            style="margin-top: 50px !important;margin-bottom: 20px !important">
            {{title}}</h1>
        </div>
        <div style="margin-right: 10px;" [attr.data-aos]="itemsAnimation ? itemsAnimation : null" fxLayout="column" fxLayout.gt-sm="row"
          fxLayoutAlign="center center">
          <div fxFlex *ngFor="let feature of features">
            <div [ngClass]="classFeature" [ngStyle]="{ 'text-align': feature.textAlignment}">
              <div [class]="'box-icon-'+feature.iconSize"
                [ngClass]="feature.iconBackgroundColorDisplay?'icon-wrapper-'+feature.iconSize:''"
                [ngStyle]="{ 'background-color': feature.iconBackgroundColor }" *ngIf="feature.icon; else imagebox">
                <i [class]="'features-material-icons-'+feature.iconSize+' material-icons'"
                  [ngStyle]="{ 'color': feature.iconColor ? feature.iconColor :'#000000' }">
                  {{ feature.icon }}
                </i>
              </div>
              <ng-template #imagebox>
                <div><img [src]="feature.image | safe:'url'"></div>
              </ng-template>
              <h3 [ngStyle]="{ 'color': feature.titleColor ? feature.titleColor : feature.textColor }"
                [innerHtml]="feature.title | safeHtml"></h3>
              <p [ngStyle]="{ 'color': feature.textColor ? feature.textColor :'#000000' }"
                [innerHtml]="feature.text | safeHtml"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-shape-matrial [shape]="shape" [backgroundColor]="backgroundColor?backgroundColor:'var(--light-bg)'"></app-shape-matrial>
</div>